import { compose } from '@reduxjs/toolkit';
import { createSectionReducer } from './createSection';
import { createStaticPageReducer } from './createStaticPage';
import { editSectionReducer } from './editSection';
import { editStaticPageReducer } from './editStaticPage';
import { fetchSectionListReducer } from './fetchSectionList';

export const extraReducers = compose(
  fetchSectionListReducer,
  createSectionReducer,
  createStaticPageReducer,
  editSectionReducer,
  editStaticPageReducer,
);

export { createSection } from './createSection';
export { createStaticPage } from './createStaticPage';
export { editSection } from './editSection';
export { editStaticPage } from './editStaticPage';
export { fetchSectionList } from './fetchSectionList';
